// extracted by mini-css-extract-plugin
module.exports = {"qrContainer":"qrcode_qrContainer_239WA","deviceInfo":"qrcode_deviceInfo_19Lqh","qrCode":"qrcode_qrCode_2MjR9","code":"qrcode_code_2-RQF","qrTitle":"qrcode_qrTitle_1Q_xy"};